import { useMemo } from 'react'
import { Outlet, Link, useLocation, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Stack from '@mui/material/Stack'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

import BreadCrumbs from '../root/components/BreadCrumbs'
import SubHeader from '../root/components/SubHeader'
import { HEADER_HEIGHT } from '../root/components/Header'

const Background = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.colors.secondaryBackground,
  height: `calc(100% - ${HEADER_HEIGHT} - 1px)`,
  width: '100%',
}))

export default function AbstractsLayout() {
  const { t } = useTranslation('abstracts')
  const { eventId } = useParams()
  const { pathname } = useLocation()

  const currentTab = useMemo(() => {
    if (pathname.includes('/abstracts/list')) {
      return '/abstracts/list'
    }
    if (pathname.includes('/abstracts/evaluation')) {
      return '/abstracts/evaluation'
    }
    return ''
  }, [pathname])

  return (
    <Background>
      <SubHeader>
        <BreadCrumbs
          hasSeparatorEnd
          links={[{ name: t('Résumés'), pathname: '' }]}
          sx={{ flex: '1 0' }}
        />
      </SubHeader>
      <Stack
        sx={theme => ({
          background: theme.palette.background.default,
          width: '100%',
          height: '100%',
          padding: '1rem',
          overflowY: 'auto',
        })}
        gap="1rem"
      >
        <Stack
          sx={theme => ({
            backgroundColor: theme.palette.background.paper,
            borderRadius: '0.5rem',
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: theme.boxShadows.main,
          })}
          padding="1rem"
          height="inherit"
          overflow="auto"
        >
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={currentTab}>
              <Tab
                label={t('Gestion de mes résumés')}
                value="/abstracts/list"
                to={eventId !== undefined ? `/abstracts/list/${eventId}` : '/abstracts/list'}
                component={Link}
              />
              <Tab
                label={t('Évaluation des résumés')}
                value="/abstracts/evaluation"
                to={
                  eventId !== undefined
                    ? `/abstracts/evaluation/${eventId}`
                    : '/abstracts/evaluation'
                }
                component={Link}
              />
            </Tabs>
          </Box>
          <Stack flexGrow="1">
            <Outlet />
          </Stack>
        </Stack>
      </Stack>
    </Background>
  )
}
